import React from 'react';
import type { CompetitorThreat } from '../types';

const TONE_TEXT: Record<CompetitorThreat['tone'], string> = {
  red:    'text-rose-700',
  orange: 'text-orange-700',
  amber:  'text-amber-700',
  slate:  'text-slate-600',
};

const CompetitorThreats: React.FC<{ threats: CompetitorThreat[] }> = ({ threats }) => {
  if (!threats || threats.length === 0) return null;
  return (
    <section className="py-4 border-b border-slate-200">
      <div className="flex items-baseline justify-between mb-3 flex-wrap gap-2">
        <h3 className="text-[13px] font-semibold text-slate-900">競合脅威度評価</h3>
        <span className="text-[11px] text-slate-500">最も注意すべき3社を抽出</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {threats.map((t) => (
          <div key={t.place_id} className="border-l-2 border-slate-200 pl-3">
            <div className="flex items-baseline justify-between gap-2 mb-1">
              <span className="text-[11px] text-slate-500">マップ {t.rank} 位</span>
              <span className={`text-[10px] font-semibold tabular-nums ${TONE_TEXT[t.tone]}`}>
                脅威度 {t.threat_label}
              </span>
            </div>
            <h4 className="text-[13px] font-semibold text-slate-900 leading-snug truncate mb-1">{t.title}</h4>
            <div className={`text-[11px] mb-2 ${TONE_TEXT[t.tone]}`}>{t.narrative}</div>
            <div className="text-[11px] space-y-0.5">
              {t.advantages.rank > 0 && <div className="flex justify-between"><span className="text-slate-600">順位差</span><span className="tabular-nums">+{t.advantages.rank}</span></div>}
              {t.advantages.reviews > 0 && <div className="flex justify-between"><span className="text-slate-600">口コミ差</span><span className="tabular-nums">+{t.advantages.reviews} 件</span></div>}
              {t.advantages.photos > 0 && <div className="flex justify-between"><span className="text-slate-600">写真差</span><span className="tabular-nums">+{t.advantages.photos} 枚</span></div>}
              {t.advantages.rating > 0 && <div className="flex justify-between"><span className="text-slate-600">評価差</span><span className="tabular-nums">+{t.advantages.rating}</span></div>}
              {t.advantages.health_score > 0 && <div className="flex justify-between"><span className="text-slate-600">健全度差</span><span className="tabular-nums">+{t.advantages.health_score} pt</span></div>}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CompetitorThreats;
